import { gql } from '@apollo/client';

export const queryName = 'multiFactorConfiguration';
export const multiFactorName = 'MultiFactorConfiguration';
export const multiFactor = gql`
	fragment ${multiFactorName} on Member {
		multiFactorConfiguration {
			smsEnrolled
			smsRequired
			totpEnrolled
			totpRequired
		}
	}
`;
